module.exports = __webpack_public_path__ + "img/canyu-modal.8b6fa24f.png";